import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { LayoutService } from '../../../Services/layout/layout.service';
import { SessionTimeoutService } from '../../../Services/session-timeout/session-timeout';
import { PlatformLocation } from '@angular/common';
import { Router, Event as RouterEvent, ActivatedRoute } from '@angular/router';
import { includes, startsWith } from 'lodash';
import { ObservablesService } from '../../../Services/observables/observables';
import { StoreService } from '../../../Services/store';
import { ActionApiService } from '../../../Services/action-api/action-api.service';
import { ConfigService } from 'src/app/Services/config.service';
const errorStages = ['kickout', 'error'];
// const noBackspaceInputs = ['radio', 'checkbox', 'hidden', 'submit', 'reset', 'button', 'select'];

@Component({
	selector: 'initInterview',
	encapsulation: ViewEncapsulation.None,
	template: ``,
	styleUrls: ['./init-interview.component.scss'],
})
export class InitInterviewComponent implements OnInit {
	showPreloader: boolean;
	ajaxInfo: any;
	constructor(
		private LayoutService: LayoutService,
		private sessionTimeoutService: SessionTimeoutService,
		location: PlatformLocation,
		private router: Router,
		private activeRoute: ActivatedRoute,
		private observablesService: ObservablesService,
		private storeService: StoreService,
		private actionApiService: ActionApiService,
		private configService: ConfigService
	) {
		this.showPreloader = false;
		location.onPopState((event: any) => {});
	}
	async ngOnInit() {
		this.LayoutService.staticLayout.subscribe((data) => {
			if (data) {
				this.showPreloader = data.data.metadata.page.state == 'preloader';
			}
		});

		//     this.router.events.subscribe((event) => {
		//       if(event instanceof NavigationStart) {
		//       let currentStage = event;

		//       }
		//       if(event instanceof NavigationEnd) {
		//         let nextStage = event.url.replace('/','');
		//         if (nextStage && includes(errorStages, nextStage.toLowerCase())) {
		//             return
		//         }
		//         }
		//   });
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		const layOutStage = this.LayoutService.staticLayout.getValue().data.metadata.page.stage; //
		const fromStage = this.router.routerState.snapshot.url.replace('/', '');
		if (layOutStage && includes(errorStages, layOutStage.toLowerCase())) {
			event.preventDefault();
		} else if (fromStage && includes(errorStages, fromStage.toLowerCase())) {
			event.preventDefault();
		} else {
			this.observablesService.showAjaxLoader.next(true);

			if (layOutStage == 'preloader') {
				this.observablesService.showPreloader.next(false);
				// Store.dispatch(fetchInterviewStage('Owners')); //todo
			} else {
				let arr = window.location.href.split('/');
				let stage = arr[arr.length - 1];
				console.log(stage);
				this.ajaxInfo = startsWith(`${this.configService.getConfig().ENV}`, 'bolt')
					? { action: 'GoToStage', stage }
					: { action: stage };

				this.actionApiService.ajaxAction(this.ajaxInfo, 'page');
				this.observablesService.ShouldPageLoadEvent = 'none';
				//  this.gtmService.virtualPageView('');//todo
			}
		}
	}
}
